













































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Respondent } from '@/store/modules/survey-store-module'
import ResponsesByRespondent from './ResponsesByRespondent.vue'
import CollapseArrow from '@/components/Survey/ResponseManagement/CollapseArrow.vue'
import router from '@/router'

@Component({
  components: {
    ResponsesByRespondent,
    CollapseArrow
  }
})
export default class ResponsesByRespondents extends Vue {
  @Prop({ required: true }) respondents!: Respondent[]
  @Prop({ required: true }) readonly respondentRemovalMap!: Record<string, boolean>
  @Prop({ required: true }) readonly responseRemovalMap!: Record<string, boolean>
  focusedId: string = '0000'
  allExpanded: boolean = false

  @Watch('$route', { immediate: true, deep: true })
  scrollToRespondent (newRoute: typeof router.currentRoute, oldRoute?: typeof router.currentRoute) {
    if (newRoute.name !== 'by-participant') return
    if (newRoute.hash === oldRoute?.hash) return
    const id = newRoute.hash?.split('#')[1]
    if (id && this.$refs[id]) {
      this.focusedId = id
      const targetRespondent = (this.$refs[id] as Vue[])[0].$el
      setTimeout(() => {
        targetRespondent.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest'
        })
      }, 0)
    }
  }

  activated () {
    this.scrollToRespondent(this.$route)
  }

  toggleExpanded () {
    this.allExpanded = !this.allExpanded
  }

  isExpanded (respondentId: string) {
    return this.focusedId === respondentId || this.allExpanded
  }

  get expandHelperText () {
    return this.allExpanded ? 'Collapse all' : 'Expand all'
  }

  toggleRespondentRemoval (payload: { respondent: Respondent, shiftClick: boolean }, index: number) {
    this.$emit('toggleRespondentRemoval', Object.assign(payload, { index }))
  }

  toggleResponseRemoval (payload: { response: Response }, index: number) {
    this.$emit('toggleResponseRemoval', Object.assign(payload, { index }))
  }
}
